<!-- eslint-disable vue/no-mutating-props -->
<template>
    <br>
    <div class="alert alert-warning alert-dismissible" style="padding:15px;">
        <h5><i class="fas fa-exclamation-triangle"></i> {{$t('general.reclamado')}}</h5>
        <div class="row">
            <div ref="col1" class="col" style="max-width: 210px;">
                <div class="input-group" :title="$t('general.fecha') + ' ' + $t('general.reclamacion')">
                    <Calendar :style="estiloreducido" dateFormat="dd/mm/yy"
                        style="max-width: 150px;" v-model="fecha_reclamacion_trabajo"
                        :readonly="trabajodatos.reclamado_liquidado != 0" />
                    <div class="input-group-append">
                        <span :style="estiloreducido" class="input-group-text"><i class="fas fa-calendar-alt"></i></span>
                    </div>
                </div>
                <div>
                    <span v-if="trabajodatos.reclamado_liquidado" title="Reclamado en autofactura" class="badge bg-success">{{ trabajodatos.factura_reclamado.prefijo }} nº{{ trabajodatos.factura_reclamado.numero }} Fecha: {{ trabajodatos.factura_reclamado.fecha }}</span>
                    <span v-if="trabajodatos.reclamacion_anulada_pendiente=='1'" title="Reclamación pendiente de ser anulada" class="badge bg-danger">Pendiente de anulación</span>
                    <span v-if="trabajodatos.factura_reclamado_anulado" title="Reclamación anulada en autofactura" class="badge bg-danger">{{ trabajodatos.factura_reclamado_anulado.prefijo }} nº{{ trabajodatos.factura_reclamado_anulado.numero }} Fecha: {{ trabajodatos.factura_reclamado_anulado.fecha }}</span>
                </div>
            </div>
            <div ref="col2" class="col">
                <div class="form-group">
                    <textarea style="resize:both;font-size:12px;" @input="autosave=true" class="form-control input-xs"
                        v-model="texto_reclamacion_trabajo" :placeholder="$t('general.motivo')" rows="1"
                        :readonly="trabajodatos.reclamado_liquidado != 0"></textarea>
                </div>
            </div>
            <div ref="col3" class="col" style="max-width: 180px">
                <div class="input-group" :title="$t('general.precio')+' a '+$t('general.descontar')">
                    <input :style="estiloreducido" style="min-width: 90px;" @input="autosave=true; calculartotal()" type="Number"
                        class="form-control input-xs" v-model="cantidad_reclamacion_trabajo" :placeholder="$t('general.precio')"
                        :readonly="trabajodatos.reclamado_liquidado != 0">
                    <div class="input-group-append">
                        <span :style="estiloreducido" class="input-group-text"><i class="fab fa-creative-commons-nc-eu"></i></span>
                    </div>
                </div>
            </div>
            <div v-if="trabajodatos.destinatario_trabajo=='operario'" ref="col4" class="col" style="max-width: 220px">
                <div class="custom-control custom-switch">
                    <input 
                        type="checkbox" 
                        @click="anularreclamacion" 
                        v-model="trabajodatos.reclamacion_anulada_pendiente" 
                        class="custom-control-input"
                        :id="'check-anular-' + trabajodatos.idtrabajo_servicio"
                        :disabled="trabajodatos.reclamacion_anulada_devuelta != 0"
                    >
                    <label v-if="trabajodatos.reclamado_liquidado != 0" class="custom-control-label" :for="'check-anular-' + trabajodatos.idtrabajo_servicio">
                        {{ $t('general.anular')}} {{$t('general.reclamacion')}}
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { PwgsApi } from '../../../../services/PwgsApi';
import Calendar from 'primevue/calendar'


export default ({
    props: ['trabajodatos','guardar'],
    setup() {
        return;
    },
    components: {
        Calendar
    },
    data() {
        return {
            reclamados: '',
            fecha_reclamacion_trabajo: '',
            texto_reclamacion_trabajo: '', 
            cantidad_reclamacion_trabajo: '',
            pendiente: '',
            devuelta: '',
            estiloreducido:'height:30px;font-size:12px;text-align:right;'
        };
    },
    methods: {
        cargardatos() { 
            this.fecha_reclamacion_trabajo = new Date(this.$props.trabajodatos.fecha_reclamacion_trabajo).toLocaleDateString('es-ES');
            this.texto_reclamacion_trabajo = this.$props.trabajodatos.texto_reclamacion_trabajo;
            this.cantidad_reclamacion_trabajo = this.$props.trabajodatos.cantidad_reclamacion_trabajo;
            this.pendiente = this.$props.trabajodatos.reclamacion_anulada_pendiente;
            this.devuelta = this.$props.trabajodatos.reclamacion_anulada_devuelta;
            // eslint-disable-next-line vue/no-mutating-props
            if(this.trabajodatos.reclamacion_anulada_pendiente==1){this.trabajodatos.reclamacion_anulada_pendiente=true;}
        },
        async anularreclamacion() {
            const api = new PwgsApi();
            let valor = (this.trabajodatos.reclamacion_anulada_pendiente == true || this.trabajodatos.reclamacion_anulada_pendiente == 1) ? '0' : '1';
            
            let subidadatos = { reclamado_anular: valor };
            try {
                await api.put('trabajos/' + this.trabajodatos.idtrabajo_servicio + '/reclamar', subidadatos);
            } catch (error) {
                this.$toast.add({ severity: 'error', summary: "Error", detail: error, life: 5000 });
            }
        },
        parseFecha(fecha) {
            if (!fecha) return null;
            if (fecha instanceof Date) return fecha;
            
            if (typeof fecha === 'string') {
                // Manejar formato ISO (si viene de BD como 2024-05-20)
                if (fecha.includes('-')) {
                    const d = new Date(fecha);
                    return isNaN(d.getTime()) ? null : d;
                }
                // Manejar formato DD/MM/YYYY (si viene de toLocaleDateString)
                let partes = fecha.split('/');
                if (partes.length === 3) {
                    return new Date(partes[2], partes[1] - 1, partes[0]);
                }
            }
            return null;
        }
    },
    mounted() {
        this.cargardatos();
    },
    watch: {
        fecha_reclamacion_trabajo(newVal) {
            let auxfechareclama = '';
            
            // 1. Si el valor es nulo o vac�o, emitimos vac�o y salimos
            if (!newVal || newVal === '0000-00-00') {
                this.$emit('update:trabajodatos', { ...this.trabajodatos, fecha_reclamacion_trabajo: '' });
                return;
            }

            // 2. Intentamos parsear
            let fecha = this.parseFecha(newVal);
            
            // 3. SEGURIDAD: Si parseFecha devolvi� null, no seguimos para evitar el error
            if (!fecha || isNaN(fecha.getTime())) {
                return; 
            }

            // 4. Ahora es seguro usar toLocaleDateString
            let auxdiafin = fecha.toLocaleDateString("es-ES", { day: '2-digit' });
            let auxmesfin = fecha.toLocaleDateString("es-ES", { month: '2-digit' });
            let auxanofin = fecha.toLocaleDateString("es-ES", { year: 'numeric' });

            auxfechareclama = `${auxdiafin}/${auxmesfin}/${auxanofin}`;
            
            // Evitar bucle infinito: solo emitir si el valor es realmente distinto
            if (this.trabajodatos.fecha_reclamacion_trabajo !== auxfechareclama) {
                this.$emit('update:trabajodatos', { ...this.trabajodatos, fecha_reclamacion_trabajo: auxfechareclama });
            }
        },
        texto_reclamacion_trabajo(newVal) {
            this.$emit('update:trabajodatos', { ...this.trabajodatos, texto_reclamacion_trabajo: newVal });
        },
        cantidad_reclamacion_trabajo(newVal) {
            this.$emit('update:trabajodatos', { ...this.trabajodatos, cantidad_reclamacion_trabajo: newVal });
        }
    }
})
</script>